import { createFileRoute } from '@tanstack/react-router'
import { AuditorVendorsPage, auditorVendorSearchSchema } from '@/components/auditor-center/AuditorVendorsPage'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/vendors',
)({
  validateSearch: auditorVendorSearchSchema,
  component: AuditorVendorsPage,
})
